import gql from 'graphql-tag'

const GC_USER_INFOS = gql`
query getCurrentUser ($id:uuid!) {
  users(where: {id: {_eq: $id}}) {
    id
    name
    first_name
    experienced
    mailing
  }
  lastPage: logs(where: {logType: {slug: {_eq: "last_visited_page"}}, user_id: {_eq: $id}}, order_by: {updated_at: asc}) {
  	id
    data
  }
  courseEnd: logs(where: {logType: {slug: {_eq: "course_end"}}, user_id: {_eq: $id}}, order_by: {updated_at: asc}) {
  	id
  }
}
`

const GC_UPDATE_USER = gql `
mutation UpdateUser($id:uuid!, $experienced: Boolean = false, $fName:String!, $lName:String!, $status: Int = 0, $organizations: [user_organisations_insert_input!]!, $position: String = "", $company: String = "", $seniority: Int = 0, $experienceSeminar: Boolean = false, $experienceCourse: Boolean = false, $experienceOther: Boolean = false, $mailing: Boolean = false) {
	update_users_by_pk(pk_columns: {id: $id}, _set: {
		experienced: $experienced,
		first_name: $fName,
		name: $lName,
		status: $status,
		position: $position,
		company: $company,
		seniority: $seniority,
		experience_seminar: $experienceSeminar,
		experience_course: $experienceCourse,
		experience_other: $experienceOther,
		mailing: $mailing,
	}) {
		id
	}
	delete_user_organisations(where: {user: {_eq: $id}}) {
		affected_rows
	}
	insert_user_organisations(objects: $organizations) {
		affected_rows
	}
}
`
// todo:
// , $orgas: [user_organisations_insert_input!]!
// 	delete_user_organisations(where: {user: {_eq: $id}}) {
// 		affected_rows
// 	}
// 	insert_user_organisations(objects: $orgas) {
// 		affected_rows
// 	}
// }
// `

const GC_UPDATE_USER_PROFIL = gql `
mutation UpdateUser($id:uuid!, $experienced: Boolean = false, $fName:String!, $lName:String!, $mailing: Boolean = false) {
	update_users_by_pk(pk_columns: {id: $id}, _set: {
		experienced: $experienced,
		first_name: $fName,
		name: $lName,
		mailing: $mailing,
	}) {
		id
	}
}
`

export {
    GC_USER_INFOS,
    GC_UPDATE_USER,
    GC_UPDATE_USER_PROFIL
}